<template>
  <div class="perfil-page">
    <section v-if="!idCliente" class="perfil-empty">
      <h1>Tu perfil Maxica</h1>
      <p>
        Recuerda iniciar sesion solo con tu numero de telefono para reclamar
        puntos Maxica y ver tus pedidos.
      </p>
      <router-link to="/tienda">Volver a la tienda</router-link>
    </section>

    <section v-else class="perfil-shell">
      <div class="perfil-hero">
        <div>
          <span class="perfil-eyebrow">Mi cuenta</span>
          <h1>{{ cliente.nombre || nombreLocal || 'Cliente Maxica' }}</h1>
          <p>{{ telefonoPerfil }}</p>
        </div>
        <router-link to="/tienda" class="perfil-shop-link">
          <i class="mdi mdi-storefront-outline"></i>
          Seguir comprando
        </router-link>
      </div>

      <div v-if="cargando" class="perfil-loading">Cargando perfil...</div>

      <template v-else>
        <div class="perfil-stats">
          <article>
            <span>MaxiPuntos</span>
            <strong>{{ formatoNumero(resumen.puntos) }}</strong>
          </article>
          <article>
            <span>Pedidos</span>
            <strong>{{ formatoNumero(resumen.totalPedidos) }}</strong>
          </article>
          <article>
            <span>Unidades compradas</span>
            <strong>{{ formatoNumero(resumen.unidades) }}</strong>
          </article>
          <article>
            <span>Total historico</span>
            <strong>{{ formatoMoneda(resumen.totalHistorico) }}</strong>
          </article>
        </div>

        <div class="perfil-grid">
          <aside class="perfil-card perfil-datos">
            <h2>Datos del cliente</h2>
            <dl>
              <div>
                <dt>Nombre</dt>
                <dd>{{ cliente.nombre || 'Sin registrar' }}</dd>
              </div>
              <div>
                <dt>Telefono</dt>
                <dd>{{ telefonoPerfil }}</dd>
              </div>
              <div>
                <dt>Direccion</dt>
                <dd>{{ cliente.direccion || 'Pendiente por completar' }}</dd>
              </div>
              <div>
                <dt>Documento</dt>
                <dd>{{ cliente.nit || 'Pendiente por completar' }}</dd>
              </div>
              <div>
                <dt>Tipo</dt>
                <dd>{{ cliente.tipoCliente2 || cliente.tipoCliente || 'Cliente' }}</dd>
              </div>
            </dl>
            <router-link to="/maxi-puntos" class="perfil-secondary-link">
              Ver productos para puntos
            </router-link>
          </aside>

          <main class="perfil-card perfil-pedidos">
            <div class="pedidos-title-row">
              <h2>Historial de pedidos</h2>
              <span>{{ pedidos.length }} registros</span>
            </div>

            <div v-if="!pedidos.length" class="sin-pedidos">
              Aun no tienes pedidos registrados.
            </div>

            <article v-for="pedido in pedidos" :key="pedido.id" class="pedido-card">
              <div class="pedido-header">
                <div>
                  <strong>Pedido #{{ pedido.id }}</strong>
                  <span>{{ pedido.fecha || 'Sin fecha' }}</span>
                </div>
                <span class="estado-pill">{{ estadoPedidoVisible(pedido) }}</span>
              </div>

              <div class="pedido-meta">
                <span><i class="mdi mdi-map-marker-outline"></i>{{ pedido.direccion || 'Sin direccion' }}</span>
                <strong>{{ formatoMoneda(pedido.total) }}</strong>
              </div>

              <div class="productos">
                <div
                  v-for="prod in pedido.productos"
                  :key="prod.id || `${pedido.id}-${prod.idProducto}-${prod.talla}`"
                  class="producto"
                >
                  <img :src="normalizarImagen(prod.imagen)" alt="" class="producto-img" />
                  <div>
                    <strong>{{ prod.nombreProducto }}</strong>
                    <span v-if="prod.codigoProducto">Ref. {{ prod.codigoProducto }}</span>
                    <span>
                      {{ prod.cantidad }} und.
                      <template v-if="prod.talla">- Talla {{ prod.talla }}</template>
                    </span>
                    <em v-if="prod.observaciones">{{ prod.observaciones }}</em>
                  </div>
                  <strong>{{ formatoMoneda(Number(prod.precio || 0) * Number(prod.cantidad || 0)) }}</strong>
                </div>
              </div>
            </article>
          </main>
        </div>
      </template>
    </section>
  </div>
</template>

<script>
import HttpService from "@/Servicios/HttpService";

export default {
  name: "MiPerfil",
  data() {
    return {
      cliente: {},
      pedidos: [],
      resumen: {
        puntos: 0,
        totalPedidos: 0,
        totalHistorico: 0,
        unidades: 0,
      },
      cargando: false,
    };
  },
  computed: {
    idCliente() {
      return localStorage.getItem("id");
    },
    nombreLocal() {
      return localStorage.getItem("nombre") || "";
    },
    telefonoPerfil() {
      return (
        this.cliente.telefono ||
        localStorage.getItem("telefono") ||
        localStorage.getItem("usuario") ||
        "Sin telefono"
      );
    },
  },
  mounted() {
    this.obtenerPerfil();
  },
  methods: {
    async obtenerPerfil() {
      if (!this.idCliente) return;
      this.cargando = true;
      try {
        const res = await HttpService.obtenerConConsultas("clientes.php", {
          accion: "perfil_cliente",
          idCliente: this.idCliente,
        });

        if (res && res.estado) {
          this.cliente = res.cliente || {};
          this.pedidos = res.pedidos || [];
          this.resumen = {
            ...this.resumen,
            ...(res.resumen || {}),
          };
          localStorage.setItem("puntos", this.resumen.puntos || 0);
          if (this.cliente.telefono) localStorage.setItem("telefono", this.cliente.telefono);
          if (this.cliente.direccion) localStorage.setItem("direccion", this.cliente.direccion);
          if (this.cliente.nit) localStorage.setItem("nit", this.cliente.nit);
        }
      } finally {
        this.cargando = false;
      }
    },
    formatoMoneda(valor) {
      return "$" + Number(valor || 0).toLocaleString("es-CO");
    },
    formatoNumero(valor) {
      return Number(valor || 0).toLocaleString("es-CO");
    },
    estadoPedidoVisible(pedido) {
      const estado = String((pedido && pedido.estado) || "CREADO").toUpperCase();
      if (estado === "CREADO" || estado === "PENDIENTE") return "En gestion";
      return estado;
    },
    normalizarImagen(ruta) {
      if (!ruta) return "img/sin-fotos-maxica.svg";
      const valor = String(ruta);
      if (valor.includes("http")) return valor;
      return valor.replace("../api/", "https://maxica.com.co/ximena/api/");
    },
  },
};
</script>

<style scoped>
.perfil-page {
  min-height: 100vh;
  background: #f7f4ef;
  padding: 32px 20px 56px;
  font-family: "Poppins", Arial, sans-serif;
  color: #171717;
}

.perfil-shell,
.perfil-empty {
  max-width: 1180px;
  margin: 0 auto;
}

.perfil-empty {
  background: #fff;
  border: 1px solid #e7ded4;
  border-radius: 8px;
  padding: 32px;
  text-align: center;
}

.perfil-empty h1 {
  margin: 0 0 8px;
  font-size: 1.8rem;
}

.perfil-empty p {
  color: #665f58;
  margin: 0 auto 18px;
  max-width: 560px;
}

.perfil-empty a,
.perfil-shop-link,
.perfil-secondary-link {
  color: #fff;
  background: #111;
  min-height: 42px;
  padding: 0 16px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-decoration: none;
  font-weight: 800;
}

.perfil-hero {
  background: #111111;
  color: #fff;
  border-radius: 8px;
  padding: 28px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
}

.perfil-eyebrow {
  display: block;
  margin-bottom: 8px;
  color: #d7c9b9;
  font-size: 0.78rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.12em;
}

.perfil-hero h1 {
  margin: 0;
  font-size: clamp(1.8rem, 4vw, 3rem);
  line-height: 1.05;
  letter-spacing: 0;
}

.perfil-hero p {
  margin: 8px 0 0;
  color: #ddd7d0;
}

.perfil-shop-link {
  background: #fff;
  color: #111;
  flex: 0 0 auto;
}

.perfil-loading {
  padding: 34px;
  text-align: center;
  color: #655d55;
}

.perfil-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin: 18px 0;
}

.perfil-stats article,
.perfil-card {
  background: #fff;
  border: 1px solid #e7ded4;
  border-radius: 8px;
}

.perfil-stats article {
  padding: 18px;
}

.perfil-stats span {
  display: block;
  color: #716960;
  font-size: 0.82rem;
  font-weight: 700;
}

.perfil-stats strong {
  display: block;
  margin-top: 5px;
  font-size: 1.35rem;
  color: #111;
}

.perfil-grid {
  display: grid;
  grid-template-columns: 320px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
}

.perfil-card {
  padding: 20px;
}

.perfil-card h2 {
  margin: 0 0 16px;
  font-size: 1.15rem;
  color: #111;
}

.perfil-datos dl {
  margin: 0;
}

.perfil-datos dl > div {
  border-bottom: 1px solid #f0ebe5;
  padding: 11px 0;
}

.perfil-datos dt {
  color: #756d65;
  font-size: 0.78rem;
  font-weight: 800;
  text-transform: uppercase;
}

.perfil-datos dd {
  margin: 3px 0 0;
  color: #1b1b1b;
  font-weight: 650;
}

.perfil-secondary-link {
  width: 100%;
  margin-top: 16px;
  background: #315a3d;
}

.pedidos-title-row,
.pedido-header,
.pedido-meta,
.producto {
  display: flex;
  align-items: center;
}

.pedidos-title-row,
.pedido-header,
.pedido-meta {
  justify-content: space-between;
  gap: 14px;
}

.pedidos-title-row span {
  color: #716960;
  font-size: 0.86rem;
  font-weight: 700;
}

.sin-pedidos {
  padding: 28px;
  background: #faf7f2;
  border: 1px dashed #d7cbbf;
  border-radius: 8px;
  color: #675f57;
  text-align: center;
}

.pedido-card {
  border-top: 1px solid #eee8e0;
  padding: 18px 0;
}

.pedido-card:last-child {
  padding-bottom: 0;
}

.pedido-header strong,
.pedido-header span {
  display: block;
}

.pedido-header span {
  margin-top: 2px;
  color: #716960;
  font-size: 0.84rem;
}

.estado-pill {
  background: #edf7ef;
  color: #315a3d;
  border: 1px solid #cbe3d0;
  border-radius: 999px;
  padding: 5px 10px;
  font-size: 0.75rem;
  font-weight: 850;
}

.pedido-meta {
  margin: 12px 0;
  color: #5e5750;
  font-size: 0.9rem;
}

.pedido-meta span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
}

.productos {
  display: grid;
  gap: 10px;
}

.producto {
  gap: 12px;
  padding: 10px;
  border: 1px solid #f0ebe5;
  border-radius: 7px;
  background: #fffdfb;
}

.producto-img {
  width: 64px;
  height: 74px;
  object-fit: contain;
  border-radius: 6px;
  background: #f4f4f4;
  flex: 0 0 auto;
}

.producto > div {
  min-width: 0;
  flex: 1;
}

.producto strong,
.producto span,
.producto em {
  display: block;
}

.producto span,
.producto em {
  color: #6d655e;
  font-size: 0.84rem;
}

.producto > strong {
  flex: 0 0 auto;
  color: #111;
}

@media (max-width: 820px) {
  .perfil-page {
    padding: 18px 12px 44px;
  }

  .perfil-hero {
    display: block;
    padding: 22px;
  }

  .perfil-shop-link {
    width: 100%;
    margin-top: 18px;
  }

  .perfil-stats {
    grid-template-columns: repeat(2, 1fr);
  }

  .perfil-grid {
    grid-template-columns: 1fr;
  }

  .producto {
    align-items: flex-start;
  }

  .producto > strong {
    display: none;
  }
}
</style>
